import { InjectionToken } from '@angular/core';

/** Loads module federation remotes (webpack "var" containers) - abstracts the host's federation runtime (webpack or @module-federation/runtime). */
export interface RemoteModuleLoader {
  /** Makes the remote known to the host - depending on the runtime, the entry script is loaded right away or on the first loadRemoteModule */
  loadRemoteEntry(remoteEntryUrl: string, remoteName: string): Promise<void>;
  loadRemoteModule<T = unknown>(remoteName: string, exposedModule: string): Promise<T>;
}

/**
 * Optional - provide it for hosts that are not built with webpack + ModuleFederationPlugin (see provideModuleFederationRuntime).
 * Consumers fall back to the webpack loader of @angular-architects/module-federation if nothing is provided.
 */
export const REMOTE_MODULE_LOADER = new InjectionToken<RemoteModuleLoader>('REMOTE_MODULE_LOADER');
